<script lang="ts" setup>
import AdminDashboardStats from "~components/admin/AdminDashboardStats.vue"
import AdminDashboardSubscribers from "~components/admin/AdminDashboardSubscriberStats.vue"
import {route} from "../../common/utils/ziggy"
</script>

<template>
  <div class="d-flex justify-content-center">
    <b-row>
      <b-col md="12">
        <AdminDashboardStats :endpoint="route('admin.api.statistics')"/>
      </b-col>
      <b-col md="3">
        <AdminDashboardSubscribers :endpoint="route('admin.api.subscriber_statistics')"/>
      </b-col>
    </b-row>
  </div>
</template>
